import LargeContainer from '@/components/front-office/containers/LargeContainer';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UserInfoLayout = ({ children }) => {
	const [isMobile, setIsMobile] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
		setIsMobile(window.innerWidth <= 768); // Détecte si la largeur de l'écran est inférieure ou égale à 768px
		};

		handleResize(); // Vérifie une première fois lors du montage
		window.addEventListener('resize', handleResize); // Ajoute l'événement resize pour ajuster au redimensionnement

		return () => {
		window.removeEventListener('resize', handleResize); // Nettoie l'événement lors du démontage du composant
		};
	}, []);

	return (
		<LargeContainer withImage={false}>
			<div>
				<h1 className="text-center font-bold text-4xl mb-4">Mon compte</h1>
				<div className="grid gap-4 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4">
					{!isMobile && <div className="col-span-1 border-r border-r-black p-4">
						<ul className="list-none text-xl flex flex-col gap-4">
							<li onClick={() => navigate('/me')}>Mes informations</li>
							<li>Mes commandes</li>
							<li>Mes adresses</li>
							<li>Mes factures</li>
						</ul>
					</div>
					}

					<div className="col-span-2">{children}</div>
				</div>
			</div>
		</LargeContainer>
	);
};

export default UserInfoLayout;
